import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import moment from "jalali-moment";
import { Box, Typography, Button, Grid } from "@mui/material";
import { TICKETING_API } from "../../api";
import { addErrorMessage, addSuccessMessage, setBackIcon, setPageTitle } from "../../slice";
import { useDate } from "../../hooks";
import BaseTextArea from "../all-inputs/BaseTextArea";

function TicketingChat() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const { persian, persian_fa, gregorian, gregorian_en, convertDate } = useDate();
  const [questions, setQuestions] = useState({
    question: {},
    questionInfos: [],
  });
  const [message, setMessage] = useState();

  const { mutateAsync: AddQuestionInfo } = useMutation(
    (body) => TICKETING_API.AddQuestionInfo(body),
    {
      onError: ({ response }) => {
        //todo : check shodan
        dispatch(addErrorMessage(response));
      },
      onSuccess: ({ data }, body) => {
        if (data.success) {
          //todo : inja bayad chekar konam
          dispatch(addSuccessMessage(data.message));
          getAllQuestions();
          setMessage("");
        }
      },
    }
  );

  const handleSubmitForm = () => {
    let body = { questionId: questions.question.id, message: message };
    AddQuestionInfo(body);
  };

  const { refetch: getAllQuestions } = useQuery(
    ["getAllQuestions"],
    () => TICKETING_API.GetQuestionInfosGrid(id),
    {
      onSuccess: ({ data }) => {
        if (data.success) {
          setQuestions(data.data);
          dispatch(
            setPageTitle(
              data.data.question.categoryName === undefined ? "" : data.data.question.categoryName
            )
          );
          dispatch(setBackIcon({ hasBackIcon: true, route: "/ticketing", hasTitleRoute: true }));
        }
      },
      onError: ({ response }) => {
        dispatch(addErrorMessage(response));
      },
    }
  );

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-end"
      justifyContent="space-between"
      height={{ xs: "76vh", sm: "77vh", lg: "67.5vh", xl: "76vh" }}
      maxHeight={{ xs: "76vh", sm: "77vh", lg: "67.5vh", xl: "76vh" }}
      minHeight={{ xs: "76vh", sm: "77vh", lg: "67.5vh", xl: "76vh" }}
      sx={{
        position: "relative",
      }}
    >
      <Box display="flex" flexDirection="column" sx={{ overflowY: "auto" }} width="100%" pr={2}>
        <Box
          display="flex"
          flexDirection="row"
          alignItems="flex-end"
          justifyContent="flex-end"
          mb={2}
          width="100%"
        >
          <Typography variant="h6"> عنوان تیکت: {questions.question.title} </Typography> /
          <Typography variant="h6">{questions.question.number}</Typography>
        </Box>
        {questions.questionInfos.map(
          ({ isRelatedExpert = false, message = "", createDate = "T" }) => {
            return (
              <Grid minWidth="100%">
                {!isRelatedExpert ? (
                  <Grid
                    container
                    display="flex"
                    flexDirection="column"
                    justifyContent="flex-end"
                    alignItems="flex-end"
                    minWidth="60%"
                    my={1}
                  >
                    <Grid
                      container
                      maxWidth={"57%"}
                      minHeight="3rem"
                      sx={{
                        backgroundColor: "#F1F0F0",
                        borderRadius: "16px",
                        color: "#4C466F",
                        direction: "rtl",
                      }}
                      px={3}
                      py={1}
                    >
                      {message}
                    </Grid>
                    <Grid
                      sx={{
                        borderTopWidth: "9px",
                        borderTopStyle: "solid",
                        borderTopColor: "transparent",
                        borderRightWidth: "12px",
                        borderRightStyle: "solid",
                        borderRightColor: "#F1F0F0",
                        transform: "rotateX(180deg)",
                      }}
                      mr={2}
                      mb={1}
                    />
                    <Typography variant="h6">
                      تیکت شما : {moment(createDate.split(" ")[0]).format("HH:mm")} -{" "}
                      {convertDate(
                        createDate.split("T")[0],
                        {
                          calendar: gregorian,
                          locale: gregorian_en,
                          format: "YYYY-MM-DD",
                        },
                        { calendar: persian, locale: persian_fa, format: "dddd YYYY/MM/DD" }
                      )}
                    </Typography>
                  </Grid>
                ) : (
                  <Grid
                    container
                    display="flex"
                    flexDirection="column"
                    justifyContent="flex"
                    minWidth="100%"
                    my={1}
                    mb={3}
                  >
                    <Grid
                      container
                      maxWidth={"57%"}
                      minHeight="3rem"
                      sx={{
                        backgroundColor: "#E8447D",
                        borderRadius: "16px",
                        color: "#FFFFFF",
                        direction: "rtl",
                      }}
                      px={3}
                      py={1}
                    >
                      {message}
                    </Grid>
                    <Grid
                      sx={{
                        borderBottomWidth: "9px",
                        borderBottomStyle: "solid",
                        borderBottomColor: "transparent",
                        borderLeftWidth: "12px",
                        borderLeftStyle: "solid",
                        borderLeftColor: "#E8447D",
                      }}
                      ml={2}
                      mb={1}
                    />
                    <Typography variant="h6">
                      پاسخ کارشناس : {moment(createDate.split(" ")[0]).format("HH:mm")} -{" "}
                      {convertDate(
                        createDate.split("T")[0],
                        {
                          calendar: gregorian,
                          locale: gregorian_en,
                          format: "YYYY-MM-DD",
                        },
                        { calendar: persian, locale: persian_fa, format: "dddd YYYY/MM/DD" }
                      )}
                    </Typography>
                  </Grid>
                )}
              </Grid>
            );
          }
        )}
      </Box>
      <Grid
        container
        display="flex"
        justifyContent="center"
        alignItem="center"
        sx={{
          backgroundColor: "#eeeeee",
          borderRadius: "16px",
          color: "#4C466F",
          position: "sticky",
          bottom: 0,
          width: "100%",
        }}
        py={2}
        pt={3}
        px={5}
      >
        <Grid
          container
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="flex-end"
        >
          <Typography variant="h6" pb={2}>
            :پیام خود را اینجا تایپ نمایید
          </Typography>
          <BaseTextArea
            placeholder="مشکل خود را توضیح دهید"
            onChange={(event) => {
              setMessage(event.target.value);
            }}
            value={message}
            flex={12}
            minRows={3}
            maxRows={3}
            style={{
              background: "#fff",
            }}
          />
        </Grid>
        <Box display="flex" justifyContent="center" mt={4} width="100%">
          {/* //// gharar shod ke pak beshe ... */}
          {/* <Button
            variant="m2"
            onClick={() => navigate("/ticketing")}
            style={{ backgroundColor: "#E8E8E8", maxHeight: "2.7rem" }}
          >
            انصراف
          </Button> */}
          <Button
            variant="m1"
            sx={{ width: "165px", ml: 2, maxHeight: "2.7rem" }}
            onClick={handleSubmitForm}
          >
            ارسال
          </Button>
        </Box>
      </Grid>
    </Box>
  );
}

export default TicketingChat;
